
import { defineComponent } from "vue";

import Header from "@/components/CarouselHeader.vue";
import Stats from "@/components/Stats.vue";
import OtherFacilitiesList from "@/components/Facilities/OtherFacilitiesList.vue";

export default defineComponent({
  components: {
    Header,
    Stats,
    OtherFacilitiesList,
  },
  data() {
    return {
      bgImg: require("@/assets/img/doctors-banner.png"),
    };
  },
});
